import axios from 'axios'
import { shownPopinsIds } from '../../utils/setLocalStorage'

export default {
  namespaced: true,
  state: {
    popins: [],
    isPopinShown: false,
    shownPopinsIds: [],
  },
  mutations: {
    SET_POPINS(state, popins) {
      state.popins = popins
    },
    SET_LOCALSTORAGE_SHOWN_POPINS_IDS(state, popinsIdsArray) {
      state.shownPopinsIds = popinsIdsArray
    },
    SET_POPIN_SHOWN(state, popin) {
      state.isPopinShown = true
      state.shownPopinsIds = [...state.shownPopinsIds, popin.id]
      shownPopinsIds(state.shownPopinsIds)
    },
  },
  actions: {
    async GET_POPINS({ rootState, commit }) {
      try {
        const { data } = await axios.get(`${rootState.api}/popins`)
        commit('SET_POPINS', data.data)
      } catch (error) {
        console.error(error);
      }
    },
  },
  getters: {
    popins: (state) => state.popins,
    activePopin: (state) => state.popins && state.popins.filter((popin) => !state.shownPopinsIds.includes(popin.id))[0],
    shouldDisplayPopin: (state, getters) => !state.isPopinShown && !!getters.activePopin,
  },
}
